import { Building2 } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { hubspotWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  hubspotWeb,
  {
    HubspotPage: () => import('./HubspotPage'),
  },
  {
    icons: { Building2 },
  },
);
